import { FieldError, useFormContext } from "react-hook-form";

import { AnnualRevenueDropdown } from "./AnnualRevenueDropdown";
import { MonthlyCollectionsDropdown } from "./MonthlyCollectionDropdown";

import { FieldLevelError } from "src/common/api";
import { OptimizelyFlag } from "src/technical-integrations/optimizely/constants";
import { useOptimizelyVariation } from "src/technical-integrations/optimizely/useOptimizelyVariation";

interface FinancialMetricFields {
  error?: FieldError;
  apiError?: FieldLevelError;
  geoValue?: string;
}

export const FinancialMetricFields: React.FC<FinancialMetricFields> = ({
  error,
  apiError,
  geoValue,
}) => {
  const { register } = useFormContext();
  const { isVariationOn } = useOptimizelyVariation({
    flag: OptimizelyFlag.SINGUP_ANNUAL_REVENUE,
  });

  return isVariationOn ? (
    <AnnualRevenueDropdown
      geoValue={geoValue}
      error={error}
      apiError={apiError}
      {...register("annual_revenue", { required: true })}
    />
  ) : (
    <MonthlyCollectionsDropdown
      error={error}
      apiError={apiError}
      {...register("monthly_collections", { required: true })}
    />
  );
};
